module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#int"
    }
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#int"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg8lev1"
    }
  }, [_vm._v("CHEESE-SCAPING")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg8lev1"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3x"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg8lev2"
    }
  }, [_vm._v("THE BASIC BALL")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg8lev2"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3x"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg8lev3"
    }
  }, [_vm._v("HOW TO TOAST NUTS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg8lev3"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3x"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg8lev4"
    }
  }, [_vm._v("CHEESE WHEEL")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg8lev4"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3x"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg9lev1"
    }
  }, [_vm._v("CHEESE LOG")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg9lev1"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3x"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg10lev1"
    }
  }, [_vm._v("MINI BALLS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg10lev1"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3x"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg10lev2"
    }
  }, [_vm._v("OWL")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg10lev2"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3x"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg12lev1"
    }
  }, [_vm._v("HEDGEHOG")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg12lev1"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3x"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg13lev1"
    }
  }, [_vm._v("PUMPKIN")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg13lev1"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07part01#part1"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Crowd-Pleasers")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07part01#part1"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#pg17lev1"
    }
  }, [_vm._v("Classic")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#pg17lev1"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#pg19lev1"
    }
  }, [_vm._v("Spinach-Artichoke")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#pg19lev1"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#pg21lev1"
    }
  }, [_vm._v("Horseradish")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#pg21lev1"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#pg22lev1"
    }
  }, [_vm._v("Ranch and Bacon")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#pg22lev1"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#pg25lev1"
    }
  }, [_vm._v("Apple Pie")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#pg25lev1"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#pg27lev1"
    }
  }, [_vm._v("Cheesecake")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#pg27lev1"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#pg28lev1"
    }
  }, [_vm._v("Port Wine")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#pg28lev1"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#pg31lev1"
    }
  }, [_vm._v("Cookie Dough")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#pg31lev1"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16part02#part2"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Afternoon Snacks")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/16part02#part2"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/17chapter09#pg34lev1"
    }
  }, [_vm._v("French Onion")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/17chapter09#pg34lev1"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/18chapter10#pg37lev1"
    }
  }, [_vm._v("Buffalo Ball")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/18chapter10#pg37lev1"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/19chapter11#pg39lev1"
    }
  }, [_vm._v("Queso")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/19chapter11#pg39lev1"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/20chapter12#pg40lev1"
    }
  }, [_vm._v("Jalapeño Popper")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/20chapter12#pg40lev1"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/21chapter13#pg43lev1"
    }
  }, [_vm._v("Herb and Jam")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/21chapter13#pg43lev1"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/22chapter14#pg45lev1"
    }
  }, [_vm._v("Horchata")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/22chapter14#pg45lev1"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/23chapter15#pg47lev1"
    }
  }, [_vm._v("Nutella")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/23chapter15#pg47lev1"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24chapter16#pg49lev1"
    }
  }, [_vm._v("Baklava")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24chapter16#pg49lev1"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/25part03#part3"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Fresh Flavors")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/25part03#part3"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/26chapter17#pg53lev1"
    }
  }, [_vm._v("Garden Herb")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/26chapter17#pg53lev1"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/27chapter18#pg54lev1"
    }
  }, [_vm._v("Greek Feta")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/27chapter18#pg54lev1"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/28chapter19#pg55lev1"
    }
  }, [_vm._v("Bruschetta")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/28chapter19#pg55lev1"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/29chapter20#pg56lev1"
    }
  }, [_vm._v("Muffuletta")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/29chapter20#pg56lev1"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/30chapter21#pg59lev1"
    }
  }, [_vm._v("Balsamic and Fig")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/30chapter21#pg59lev1"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/31chapter22#pg61lev1"
    }
  }, [_vm._v("Goat Cheese and Honey")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/31chapter22#pg61lev1"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/32chapter23#pg65lev1"
    }
  }, [_vm._v("Lemon-Citrus–Poppy Seed")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/32chapter23#pg65lev1"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/33chapter24#pg66lev1"
    }
  }, [_vm._v("Trail Mix")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/33chapter24#pg66lev1"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/34part04#part4"
    }
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Holiday Statements")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/34part04#part4"
    }
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/35chapter25#pg70lev1"
    }
  }, [_vm._v("Everything Bagel")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/35chapter25#pg70lev1"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36chapter26#pg72lev1"
    }
  }, [_vm._v("Holiday Ham")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36chapter26#pg72lev1"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/37chapter27#pg74lev1"
    }
  }, [_vm._v("Lasagna")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/37chapter27#pg74lev1"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/38chapter28#pg75lev1"
    }
  }, [_vm._v("Crab Cake")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/38chapter28#pg75lev1"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/39chapter29#pg76lev1"
    }
  }, [_vm._v("Red, White, and Blue")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/39chapter29#pg76lev1"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/40chapter30#pg79lev1"
    }
  }, [_vm._v("Pumpkin Pie")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/40chapter30#pg79lev1"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/41chapter31#pg82lev1"
    }
  }, [_vm._v("Brie with Cranberries")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/41chapter31#pg82lev1"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/42chapter32#pg85lev1"
    }
  }, [_vm._v("S’mores")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/42chapter32#pg85lev1"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/43part05#part5"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Evening Affairs")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/43part05#part5"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/44chapter33#pg88lev1"
    }
  }, [_vm._v("Roasted Garlic")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/44chapter33#pg88lev1"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/45chapter34#pg90lev1"
    }
  }, [_vm._v("Mushroom and Herb")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/45chapter34#pg90lev1"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/46chapter35#pg92lev1"
    }
  }, [_vm._v("Lemon and Saffron")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/46chapter35#pg92lev1"
    }
  }, [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/47chapter36#pg95lev1"
    }
  }, [_vm._v("Summertime Peach")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/47chapter36#pg95lev1"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48chapter37#pg97lev1"
    }
  }, [_vm._v("Spicy Mango")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48chapter37#pg97lev1"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/49chapter38#pg100lev1"
    }
  }, [_vm._v("Rainbow")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/49chapter38#pg100lev1"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/50chapter39#pg103lev1"
    }
  }, [_vm._v("Maple Bourbon")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/50chapter39#pg103lev1"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/51chapter40#pg106lev1"
    }
  }, [_vm._v("Matcha")]), _vm._v(" "), _c('span', {
    staticClass: "font1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/51chapter40#pg106lev1"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/52index#ind"
    }
  }, [_vm._v("INDEX")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/52index#ind"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/53thanks#tha"
    }
  }, [_vm._v("THANKS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/53thanks#tha"
    }
  }, [_vm._v("112")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/54author"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/54author"
    }
  }, [_vm._v("113")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f2ff718","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05-contents.vue
// module id = 69
// module chunks = 0